var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.offset !== null && (_vm.offset < 362439))?_c('span',[_vm._v(_vm._s(_vm.displayTime))]):(_vm.offset !== null && (_vm.offset >= 362439))?_c('span',[_vm._v("99:99:99")]):_c('span',{staticClass:"text-muted"})}
var staticRenderFns = []

export { render, staticRenderFns }